class ScrollToItem {
    constructor(DOMelement, elementId) {
        try {
            const targetElement = DOMelement.querySelector(elementId);

            const navbarHeight = 140;
            const scrollPosition = targetElement.offsetTop - navbarHeight;

            window.scrollTo({top: scrollPosition});

        } catch (error) {
            console.log(error);
        }
    }

}
export default ScrollToItem;